import { atom } from "jotai";
import { State } from "./State";
import { postBase } from "./BaseApi";

type ResetForm = {
  emailAddress: string;
};

export const passwordResetAtom = atom<State<null> | null>(null);
export const passwordReset = () => {
  const url = "api/password-reset";
  return postBase<null, ResetForm>(url, passwordResetAtom);
};

type SetForm = {
  email: string;
  password: string;
  token:string;
};

export const passwordSetAtom = atom<State<null> | null>(null);
export const passwordRecreate = () => {
  const url = "api/password-recreate";
  return postBase<null, SetForm>(url, passwordSetAtom);
};

